const envConfig = {
  isOnline: process.env.NEXT_PUBLIC_ONLINE === "true",
  wwwDomain: "cwallet.com",
  CCPADMINURL:
    process.env.NEXT_PUBLIC_ONLINE === "true"
      ? "https://console.ccpayment.com"
      : "https://ebc65a6dtestpaymentadmin.ccpayment.com",
};

export default envConfig;
